function decode (s) {
    return decodeURIComponent((s || '').replace(/\+/g, ' '))
}

export function queryParameters(queryString) {
  queryString = queryString || "";

  const result = {};
  let keyValuePairs, keyAndValue, key, value;

  if (queryString.search(/\?|#/) === 0) {
    queryString = queryString.slice(1);
  }

  if (queryString.length === 0) {
    return result;
  }

  keyValuePairs = queryString.split("&");

  for (let i = 0; i < keyValuePairs.length; i++) {
    keyAndValue = keyValuePairs[i].split("=");
    key = decode(keyAndValue[0]);
    value = decode(keyAndValue[1]) || "";
    result[key] = value;
  }

  return result;
}
